// Critically damped spring smoother for audio-reactive signals.
// Math (per plan):
//   dt clamped to 0.050s to survive tab-switch / GC pauses
//   a = omega^2 * (target - x) - 2 * omega * v
//   v += a * dt; x += v * dt
export class CriticallyDampedSpring {
  constructor(omega) {
    this.omega = omega;
    this.x = 0;
    this.v = 0;
    this.target = 0;
  }

  setTarget(target) {
    this.target = target;
  }

  update(dtSeconds) {
    const dt = Math.min(dtSeconds, 0.050);
    const a = this.omega * this.omega * (this.target - this.x) - 2 * this.omega * this.v;
    this.v += a * dt;
    this.x += this.v * dt;
    return this.x;
  }

  reset(x = 0, v = 0) {
    this.x = x;
    this.v = v;
  }
}

export function makeSpring(omega) {
  return new CriticallyDampedSpring(omega);
}
